module.exports = __webpack_public_path__ + "dashboard-cb3930f8e1bbe26104a1c6d4fbbc3798.png";